// extracted by mini-css-extract-plugin
export default {"close-btn":"AnonLoginModal_close-btn__uEZx2"};